<template>
  <section class="hero is-fullheight editor-page">
    <PmNavbar />
    <div class="hero-body">
      <div class="container">
        <div class="columns is-multiline pt-5 white-bg">
          <div class="column is-8 is-offset-2">
            <h3 class="is-ubuntu">Editor</h3>
          </div>
          <div class="column is-8 is-offset-2">
            <p class="font-18 is-ubuntu pb-5">
              {{ this.$t("message.pages.editorPage.subtitle") }}
            </p>
          </div>
        </div>

        <div class="columns is-multiline mt-5 white-bg">
          <div class="column is-8 is-offset-2">
            <p class="font-18 font-secondary pt-5 gray-bottom-top" v-if="product">
              Suunnittelet parhaillaan:
            </p>
            <p class="font-18 font-secondary pb-5" v-if="product">
              {{product.name}}
            </p>
          </div>
        </div>

        <div class="columns is-multiline mt-5 white-bg">
          <div class="column is-10 is-offset-1">
            <FabricComponent ref="fabriceditor" :product="product" v-if="product"></FabricComponent>
          </div>
          <div class="column is-12">
            <div class="editor-wrapper white-bg m-auto">
              <div
                class="editor-buttons-wrapper has-text-centered py-5 is-align-items-center"
              >
                <div class="columns is-multiline">
                  <div class="column is-4 is-offset-4 is-align-items-center is-justify-content-end is-relative">
                    <div class="text-wrapper is-inline-block">
                      <productAmount
                        :is-editable="true"
                        :item="selectedProduct"
                        v-model="selectedProduct.amount"
                        :product="selectedProduct.product"
                        class="is-size-5"
                      >
                      </productAmount>
                    </div>
                  </div>
                </div>
                <div class="columns is-multiline">
                  <div class="column is-4 is-offset-4 is-align-items-center is-justify-content-end is-relative">
                    <div class="column is-12 has-text-centered is-justify-content-center is-align-items-center">
                      <p class="font-18">{{ this.$t("message.pages.editorPage.costPrepText") }} {{ getVolumeDiscount(selectedProduct).price }} € = {{ Math.ceil(getItemLineTotalPrice(selectedProduct)).toFixed(2) }} € {{ this.$t("message.pages.editorPage.taxText") }} 0%</p>
                    </div>
                  </div>
                </div>
                <div class="columns is-multiline">
                  <div class="column is-2 is-offset-8 has-text-centered">
                    <button class="pyroll-button purple-bg font-white mb-2" @click="goToCart()">
                      {{ $t("message.pages.editorPage.goCartButtonText") }}
                    </button>
                    <button class="pyroll-button purple-bg font-white" @click="addProduct()">
                      {{ $t("message.pages.editorPage.addProductButtonText") }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Teleport to="body">
      <AiDesignChat :fabricComponent="fabricEditorRef" v-if="product && aiAgentEnabled" />
    </Teleport>
    <PmFooter />
  </section>
</template>

<script>
import PmNavbar from '../components/PmNavbar'
import PmFooter from '../components/PmFooter'
import productAmount from "@/components/productAmount"
import {mapActions, mapGetters, mapMutations} from "vuex"
import addProductMixin from "@/mixins/addProduct"
import FabricComponent from "@/components/FabricComponent"
import AiDesignChat from "@/components/AiDesignChat"
import cartMixin from "@/mixins/cartMixin"

export default {
  name: "EditorPage",
  components: {
    PmNavbar,
    PmFooter,
    FabricComponent,
    productAmount,
    AiDesignChat
  },
  data() {
    return {
      product: null,
      fabricEditorRef: null,
      // nginx client_max_body_size is 35 MB; stay safely under it to leave
      // room for request headers and base64/JSON encoding overhead.
      maxPayloadBytes: 33 * 1024 * 1024
    }
  },
  computed: {
    ...mapGetters(['aiAgentEnabled'])
  },
  mounted() {
    this.product = this.$store.getters.getProductById(this.$route.params.product)
    this.$nextTick(() => {
      this.fabricEditorRef = this.$refs.fabriceditor
    })
    this.getSiteSettings()
  },
  mixins: [addProductMixin, cartMixin],
  methods: {
    ...mapActions([
      'updateItem',
      'getOrder',
      'getSiteSettings'
    ]),
    ...mapMutations([
      'setSpinnerState'
    ]),
    openTab(evt, tabName) {
      var i, x, tablinks;
      x = document.getElementsByClassName("content-tab")
      for (i = 0; i < x.length; i++) {
        x[i].style.display = "none"
      }
      tablinks = document.getElementsByClassName("tab")
      for (i = 0; i < x.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" is-active", "")
      }
      document.getElementById(tabName).style.display = "flex"
      evt.currentTarget.className += " is-active"
    },
    _buildItemPayload() {
      let itemId = this.$route.params.item
      const editor = this.$refs.fabriceditor

      if (editor.isMultiSided) {
        editor.removeGrid()
        const sideDataUrls = editor.getAllSideDataUrls()
        const payload = {
          'id': itemId,
          'amount': this.selectedProduct.amount,
          'fabric_metadata': this.selectedProduct.fabric_metadata,
          'draft': false
        }
        for (const [sideName, dataUrl] of Object.entries(sideDataUrls)) {
          payload[`side_${sideName}`] = dataUrl
        }
        return payload
      } else {
        editor.removeGrid()
        editor.getDataUrl()
        return {
          'id': itemId,
          'label_png': editor.texture[0].dataUrl,
          'amount': this.selectedProduct.amount,
          'fabric_metadata': this.selectedProduct.fabric_metadata,
          'draft': false
        }
      }
    },
    _payloadWithinLimit(payload) {
      const bytes = new Blob([JSON.stringify(payload)]).size
      if (bytes > this.maxPayloadBytes) {
        this.setSpinnerState(false)
        alert(this.$t('message.pages.editorPage.imageTooLargeError'))
        return false
      }
      return true
    },
    _itemSaved(res) {
      // doAsync resolves with the error response instead of rejecting, so a
      // failed save must be detected here. Otherwise the item silently stays
      // a draft and is left out of the cart, the payment and the Omikai sync.
      if (res && res.status >= 200 && res.status < 300) return true
      this.setSpinnerState(false)
      const tooLarge = res && (res.status === 400 || res.status === 413)
      alert(this.$t(tooLarge ? 'message.pages.editorPage.imageTooLargeError' : 'message.pages.editorPage.saveError'))
      return false
    },
    addProduct() {
      this.setSpinnerState(true)
      const payload = this._buildItemPayload()
      if (!this._payloadWithinLimit(payload)) return
      this.updateItem(payload).then((res) => {
        if (!this._itemSaved(res)) return
        this.getOrder()
          .then(() => {
            this.selectProductEditor(this.product.id, this.product.resource_type, 'editor')
          })
      })
    },
    goToCart() {
      this.setSpinnerState(true)
      let uuid = this.$route.params.uuid
      const payload = this._buildItemPayload()
      if (!this._payloadWithinLimit(payload)) return
      this.updateItem(payload).then((res) => {
        if (!this._itemSaved(res)) return
        this.getOrder()
          .then(() => {
            this.setSpinnerState(false)
            this.$router.push({
              name: 'Cart',
              params: {
                uuid: uuid
              }
            })
          })
      })
    }
  },
}
</script>

<style scoped lang="scss">
@use '../assets/sass/variables' as *;
.editor-page {
  .cstm-font-color {
    color: $font-color-primary;
  }

  .white-bg {
    background-color: #ffffff;
  }

  .editor-buttons-wrapper {
    margin: auto;
  }

  .pm-button {
    width: 181px;
    height: 45px;
    font-family: $font-secondary;
    font-size: 18px;
    justify-content: center;
  }

  .svg-inline--fa {
    cursor: pointer;
  }

  .pm-small-button {
    width: 100% !important;
    @media (max-width: 768px) {
      width: 80% !important;
    }
  }
}

.gray-bottom-top {
  border-top: 2px solid #D0D3D4;
}
</style>
